<template>
  <full-screen-loader position="fixed" v-if="loading" white-bg/>
  <smd-one-col-layout class="medicine-order-details-hipres"
                      v-else
                      :content-styles="contentStylesClass">

    <template v-if="completed">
      <div class="smd-form__row align-items-center m-b-10">
        <status-icon :item="serviceOrder" class="ns-large-icon m-r-10"/>
        <text-string label-id="txt229"/>
      </div>
      <smd-note class="m-b-30">
        <text-string class="text-center" label-id="txt170"/>
      </smd-note>
      <list-item-file-labresult v-for="(file, fileIndex) in labResults"
                                :key="fileIndex"
                                :file-data="file"
                                :patient-name="patientName"/>

      <div class="flex-row-center-x-spaced justify-content-center m-t-30">
        <smd-btn type="button"
                 section="4"
                 variant="unselected"
                 @click="reportIssue">
          {{ getElementString('txt219') }}
        </smd-btn>
        <smd-btn v-if="showRebookButton"
                 type="button"
                 section="4"
                 variant="blue-enabled"
                 @click="rebook">
          {{ getElementString('txt241') }}
        </smd-btn>
      </div>

      <div class="divider--dotted m-t-30 m-b-30"></div>

      <div v-if="addedPrescriptions.length" class="added-prescriptions m-b-35">
        <text-string label-id="txt264" class="m-b-15"/>

        <div v-for="(prescription, prescriptionIndex) in addedPrescriptions"
             :key="prescriptionIndex">
          <prescription-card v-if="prescription.token"
                             :prescription="prescription"
                             class="m-b-15">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </prescription-card>

          <attached-file-card v-if="!prescription.token"
                              class="m-b-15"
                              :prescription="prescription"
                              :orderid="serviceOrder.orderid"
                              @click="viewPrescription(prescription)">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </attached-file-card>
        </div>
      </div>
    </template>

    <div class="smd-form__row justify-content-center">
      <img class="medicine-order-details-hipres__header-image" src="../../../assets/images/ico058.svg" alt="">
    </div>

    <template v-if="!completed">
      <text-string class="m-b-5" label-id="txt224"/>
      <text-string class="m-b-20" label-id="txt259"/>
    </template>

    <text-string label-id="txt245" class="m-b-20" v-if="completed"/>

    <div class="medicine-order-details-hipres__body smd-panel"
         ref="printMe">
      <div class="smd-form__row logos">
        <div class="smd-form__col">
          <img src="~@/assets/images/nowserving.png"
               class="image"
               alt="NowServing Logo">
        </div>
        <div class="smd-form__col">
          <img src="~@/assets/images/img001.png"
               class="image"
               alt="By SeriousMD Logo">
        </div>
      </div>
      <div class="smd-form__row justify-content-center hi-pres-logo m-b-30">
        <div class="smd-form__col">
          <text-string label-id="txt1422" class="m-b-10"/>
          <img src="@/assets/images/pharmacies/img005.png" alt="Hi-Pres Logo">
        </div>
      </div>

      <div class="delivery-details">
        <!--   Patient's Name     -->
        <text-string label-id="txt046" class="m-b-5"/>
        <p class="Title1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{ patientName }}</p>
        <div class="smd-two-col-grid-tiles">
          <div>
            <!--   Date of Birth     -->
            <text-string label-id="txt151" class="m-b-5"/>
            <p class="Body1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{
                patient.birthdate | formatPatientBirthdate
              }}</p>
          </div>
          <div>
            <!--   Doctor     -->
            <text-string label-id="txt260" class="m-b-5"/>
            <p class="Body1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{ doctor._fullName }}</p>
          </div>
        </div>
      </div>
      <div class="divider--dotted m-t-30 m-b-30"></div>
      <text-string class="m-b-5" label-id="txt262"/>
      <text-string class="m-b-10" label-id="txt263"/>
      <div class="smd-form__row justify-content-center">
        <h1 class="loa-id">{{ serviceOrder.loaId | formatLoaId }}</h1>
      </div>

      <div class="smd-form__row justify-content-center m-b-15"
           id="js-save-screenshot-btn">
        <smd-btn section="4"
                 variant="blue-enabled"
                 @click="saveScreenshot">
          <text-string label-id="txt223"/>
        </smd-btn>
      </div>
    </div>

    <template v-if="!completed">
      <div class="flex-row-center-x-spaced justify-content-center">
        <smd-btn v-if="!completed"
                 type="button"
                 section="4"
                 variant="unselected"
                 @click="viewInstructions">
          {{ getElementString('txt579') }}
        </smd-btn>
        <smd-btn type="button"
                 section="4"
                 variant="unselected"
                 @click="reportIssue">
          {{ getElementString('txt219') }}
        </smd-btn>
      </div>

      <div class="divider--dotted m-t-30 m-b-30"></div>

      <div v-if="addedPrescriptions.length" class="added-prescriptions m-b-35">
        <text-string label-id="txt264" class="m-b-15"/>

        <div v-for="(prescription, prescriptionIndex) in addedPrescriptions"
             :key="prescriptionIndex">
          <prescription-card v-if="prescription.token"
                             :prescription="prescription"
                             class="m-b-15">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </prescription-card>

          <attached-file-card v-if="!prescription.token"
                              class="m-b-15"
                              :prescription="prescription"
                              :orderid="serviceOrder.orderid"
                              @click="viewPrescription(prescription)">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </attached-file-card>
        </div>
      </div>
    </template>
  </smd-one-col-layout>
</template>

<script>
  import GetElementString from "@/mixins/get-element-string";
  import {formatDate} from '@/utils/dates';
  import {formatStringSpaces} from "@/utils";

  import {mapGetters} from 'vuex';
  import {Reference} from 'smd-vue-scaffold';
  import {
    GETTER_TOKENS,
    GETTER_ACCOUNT_ID,
    GETTER_DOCTOR_PATIENT_PARTNER,
  } from '@/store/types';
  import AttachedFileCard from '@/components/attached-file-card';
  import PrescriptionCard from '@/components/prescription-card';
  import ModalReportIssue from '@/components/services/modal-report-issue';
  import ToastMixin from '@/mixins/toast-mixin';
  import {STATUS_CODES} from "@/reference/medicine";
  import {FilesService} from "@/services/files";
  import ListItemFileLabresult from "@/components/list-item/list-item-file-labresult";
  import StatusIcon from "@/components/common/status-icon";
  import {transformReceivedLabResult} from "@/utils/lab-tests";
  import ModalInstructions from "@/modals/modal-instructions/modal-instructions";
  import {HIPRES_INSTRUCTION_ITEM} from "@/reference/modal-instruction-items";
  import LabRequestCouponMixin from "@/mixins/lab-request-coupon-mixin";

  export default {
    name: 'medicine-order-details-hipres',
    mixins: [
      ToastMixin,
      GetElementString,
      LabRequestCouponMixin,
    ],
    filters: {
      formatPatientBirthdate(date) {
        return formatDate(date, 'MMM D, YYYY');
      },
      formatLoaId(loaId) {
        return formatStringSpaces(loaId, 4);
      },
    },
    components: {
      StatusIcon,
      ListItemFileLabresult,
      AttachedFileCard,
      PrescriptionCard,
    },
    props: {
      serviceOrder: {type: Object, required: true},
    },
    data() {
      return {
        loading: false,
        labResults: [],
      };
    },
    computed: {
      ...mapGetters({
        tokens: GETTER_TOKENS,
        accountId: GETTER_ACCOUNT_ID,
        doctorPatientPartner: GETTER_DOCTOR_PATIENT_PARTNER,
      }),
      computedCouponLabelId() {
        return this.serviceOrder.orderid ? 'txt253' : 'txt222';
      },
      computedCouponBtnVariant() {
        return this.serviceOrder.orderid ? 'green' : 'red';
      },
      accesstoken() {
        const {accesstoken} = this.tokens.find(({token}) => token === this.serviceOrder.token);
        return accesstoken;
      },
      doctor() {
        const doctorPatientPartner = this.doctorPatientPartner[this.accesstoken];
        return doctorPatientPartner ? doctorPatientPartner.doctor : {};
      },
      patient() {
        const doctorPatientPartner = this.doctorPatientPartner[this.accesstoken];
        return doctorPatientPartner ? doctorPatientPartner.patient : {};
      },
      completed() {
        return this.serviceOrder.status === STATUS_CODES.FULFILLED;
      },
      contentStylesClass() {
        return {'dark-light-bg d-medicine-order-details-default__content-style medicine-order-details-hipres__content-style': this.$isDesktop}
      },
      addedPrescriptions() {
        if (!this.serviceOrder) return [];

        return this.serviceOrder.prescriptions.length
          ? this.serviceOrder.prescriptions
          : this.serviceOrder.files.map((file) => ({
            uploadid: file,
            token: this.serviceOrder.token,
            remarks: this.serviceOrder.remarks,
          }));
      },
      patientName() {
        if (!this.serviceOrder) return 'Unnamed';

        return [this.serviceOrder.firstname, this.serviceOrder.middlename, this.serviceOrder.lastname]
          .filter((item) => !!item)
          .join(' ');
      },
      showRebookButton() {
        return this.completed || this.serviceOrder.status < 0;
      },
    },
    mounted() {
      if (this.completed) {
        this.getLabResults();
      }
    },
    methods: {
      async getLabResults() {
        try {
          const {data} = await FilesService.getLabResults({
            loaId: this.serviceOrder.loaId,
            orderid: this.serviceOrder.orderid
          });

          this.labResults = data.map((file) => {
            return transformReceivedLabResult(file, this.doctorPatientPartner[this.accesstoken]);
          });
        } catch (error) {
          this.showToast({
            text: 'Failed to fetch lab results.',
            theme: 'danger',
          });
        }
      },
      async saveScreenshot() {
        const el = this.$refs.printMe;
        const a = document.createElement('a');
        const saveScreenshot = document.getElementById('js-save-screenshot-btn');
        const options = {
          type: 'dataURL',
          allowTaint: false,
          useCORS: true,
          logging: false,
        }
        saveScreenshot.classList.add('hidden');

        try {
          this.screenshotOutput = await this.$html2canvas(el, options);

          saveScreenshot.classList.remove('hidden');

          a.href = this.screenshotOutput
          a.download = `Hi-Precision Lab Tests.jpg`;
          a.click();
        } catch (error) {
          saveScreenshot.classList.remove('hidden');
          this.showToast({
            text: 'Failed to generate screenshot. Please try again later.',
            theme: 'danger',
          });
        }
      },
      reportIssue() {
        this.$modal.open({
          component: ModalReportIssue,
          size: Reference.SmdModalSizes.sm,
          position: 'detached auto-height',
          props: {
            orderid: this.serviceOrder.orderid,
          },
        });
      },
      viewInstructions() {
        this.$modal.open({
          component: ModalInstructions,
          position: 'detached auto-height',
          props: {
            items: HIPRES_INSTRUCTION_ITEM,
            mainTitle: 'txt348',
          },
          size: Reference.SmdModalSizes.xs,
        })
      },
      rebook() {
        this.claimCoupon(this.accesstoken, this.serviceOrder.files[0]);
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .medicine-order-details-hipres {
    .partner {
      img {
        max-height: 48px;
        margin-bottom: space(xs);
      }
    }
  }

  .medicine-order-details-hipres__header-image {
    max-width: 300px;
  }

  .medicine-order-details-hipres__body {
    @include responsive(desktop) {
      padding: space(m) space(l);

      .smd-coupon__content {
        .smd-coupon__action-btn {
          display: none;
        }

        h3 {
          margin: 10px 0;
        }
      }
    }

    .logos {
      width: 75%;
      max-width: 337px;
      margin: 8px auto space(l) auto;

      img {
        width: 100%;
      }
    }

    .loa-id {
      font-weight: 600;
      color: color(crimson);
    }

    .hi-pres-logo {
      img {
        width: 100%;
        max-width: 256px;

        @include responsive(mobile) {
          max-width: 196px;
        }
      }
    }
  }

  .d-medicine-order-details-default__content-style {
    > div {
      @include set-max-width($max-width: 900px)
    }

    @include responsive('min-width: 1024px') {
      padding: space(xl) !important;

      .smd-form--search {
        max-width: 792px;
      }
    }
  }

  .d-medicine-order-details-default__content {
    @include border-radius();
    @include box-shadow();
    background: color(white);
    padding: space(xxl);
  }

  .medicine-order-details-hipres__content-style {
    > div {
      @include border-radius();
      @include box-shadow();
      background: color(white);
      padding: space(xxl);
    }
  }
</style>
